import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, version2 } from 'ui-components/components/input';
import { ValidationMessage, MAX_CHAR_COUNT } from '../../../../fulfillment-planner/package-content-description';

const PackageContentDescriptionInputForMultiPackage = ({ initialValue, inputClassName, labelId = 'package-description-input', onBlur }) => {
  const [inputValue, setInputValue] = useState(initialValue ?? '');
  const [isTouched, setIsTouched] = useState(false);

  const handleChange = useCallback(({ target }) => {
    const { value } = target;
    setInputValue(value);
    setIsTouched(true);
  }, []);

  const handleBlur = useCallback(() => {
    onBlur(inputValue);
    setIsTouched(true);
  }, [inputValue, onBlur]);

  return (
    <Input
      className={inputClassName}
      // hasError - TODO: Add support for this
      id={labelId}
      inlineMessage={
        <ValidationMessage
          remainingCount={MAX_CHAR_COUNT - inputValue.length}
          showCount={isTouched}
          showError={isTouched && !inputValue.length}
        />
      }
      maxlength={MAX_CHAR_COUNT}
      onBlur={handleBlur}
      onChange={handleChange}
      value={inputValue}
      version={version2}
    />
  );
};

PackageContentDescriptionInputForMultiPackage.propTypes = {
  labelId: PropTypes.string,
  initialValue: PropTypes.string.isRequired,
  inputClassName: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
};

export { PackageContentDescriptionInputForMultiPackage };
